export const changeFilter = (type) => type;
export const setDefaultFilter = (type) => `${type}_TO_DEFAULT`;
